import React from 'react';

const UpArrowIcon = () => {
  return (
    <svg width="15" height="9" viewBox="0 0 15 9" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 2.957l5.89 5.89L15 7.237 7.764 0 7.5.264 7.236.001 0 7.237l1.61 1.61 5.89-5.89z" fill="currentColor" fillRule="evenodd" />
    </svg>
  );
};

export default UpArrowIcon;
